export default __webpack_public_path__ + "static/media/lprBg.9a645184.png";